export const parseLangsConfigs = (document: Document): Set<string> => {
    if (!document) {
        return new Set<string>();
    }

    try {
        const langsDocuments = Array.from(
            document.querySelectorAll("config > langs > lang")
        );

        return new Set<string>(
            Array.from(langsDocuments)
                .map((e) => e.textContent?.trim())
                .filter((e) => !!e) as string[]
        );
    } catch (e: any) {
        console.warn(
            `Could not parse base.xml > langs config! Error: ${e.message}`
        );

        return new Set<string>();
    }
};
